__turbopack_context__.v({
  "actions": "work-added-to-cart-drawer-module-scss-module__ocJFXW__actions",
  "closeButton": "work-added-to-cart-drawer-module-scss-module__ocJFXW__closeButton",
  "content": "work-added-to-cart-drawer-module-scss-module__ocJFXW__content",
  "header": "work-added-to-cart-drawer-module-scss-module__ocJFXW__header",
  "item": "work-added-to-cart-drawer-module-scss-module__ocJFXW__item",
  "itemDetails": "work-added-to-cart-drawer-module-scss-module__ocJFXW__itemDetails",
  "itemTitle": "work-added-to-cart-drawer-module-scss-module__ocJFXW__itemTitle",
  "paper": "work-added-to-cart-drawer-module-scss-module__ocJFXW__paper",
  "recommendations": "work-added-to-cart-drawer-module-scss-module__ocJFXW__recommendations",
  "root": "work-added-to-cart-drawer-module-scss-module__ocJFXW__root",
  "shipping": "work-added-to-cart-drawer-module-scss-module__ocJFXW__shipping",
  "shippingDetails": "work-added-to-cart-drawer-module-scss-module__ocJFXW__shippingDetails",
  "shippingMessage": "work-added-to-cart-drawer-module-scss-module__ocJFXW__shippingMessage",
  "shippingProgress": "work-added-to-cart-drawer-module-scss-module__ocJFXW__shippingProgress",
  "subtotal": "work-added-to-cart-drawer-module-scss-module__ocJFXW__subtotal",
  "u-animation-bounce": "work-added-to-cart-drawer-module-scss-module__ocJFXW__u-animation-bounce",
});
